import styled, { keyframes } from 'styled-components';
import { DesktopOutlined } from '@ant-design/icons';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var fadeIn = keyframes(["from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);}"]);
var UnsupportedDeviceWrapper = styled.div.withConfig({
  displayName: "unsupported-device__UnsupportedDeviceWrapper",
  componentId: "sc-1y0e1vn-0"
})(["display:none;@media (max-width:768px){display:flex;justify-content:center;align-items:center;position:fixed;top:0;left:0;width:100%;height:100%;background:", ";z-index:9999;padding:20px;}"], styleVariables.colors.gray1);
var UnsupportedDeviceContent = styled.div.withConfig({
  displayName: "unsupported-device__UnsupportedDeviceContent",
  componentId: "sc-1y0e1vn-1"
})(["text-align:center;background:", ";padding:40px;border-radius:16px;box-shadow:0 10px 25px rgba(0,0,0,0.1);max-width:500px;width:100%;animation:", " 0.5s ease-out forwards;h1{font-size:24px;font-weight:600;margin-top:20px;margin-bottom:8px;}p{font-size:16px;line-height:1.6;}"], styleVariables.colors.colorBgContainer, fadeIn);
var IconWrapper = styled.div.withConfig({
  displayName: "unsupported-device__IconWrapper",
  componentId: "sc-1y0e1vn-2"
})(["font-size:48px;color:", ";"], styleVariables.colors.colorPrimaryBase);
export var UnsupportedDevice = function UnsupportedDevice() {
  return /*#__PURE__*/_jsx(UnsupportedDeviceWrapper, {
    children: /*#__PURE__*/_jsxs(UnsupportedDeviceContent, {
      children: [/*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(DesktopOutlined, {})
      }), /*#__PURE__*/_jsx("h1", {
        children: "Unsupported Device"
      }), /*#__PURE__*/_jsx("p", {
        children: "For the best experience, please access this application on a tablet or desktop computer."
      })]
    })
  });
};